import { useAppDispatch } from 'app/core/hooks'
import { MnuList, noTiList } from 'app/core/models/api/com/com0102'
import { Com0204CtlrOut } from 'app/core/models/api/com/com0204'
import {
    useLazySelectCacheInfoQuery,
    useLazySelectCom0204Query,
    useLazySelectMnu0102Query,
} from 'app/core/services/com/com.service'
import { MenuDict } from 'app/core/slices/user/menu.slice'
import { clear as userClear } from 'app/core/slices/user/user.slice'
import { clear as mobileClear } from 'app/core/slices/user/mobileAuth.slice'
import { clear as bankingClear } from 'app/core/slices/user/bankingInfo.slice'
import MAIAPP0103 from 'app/pages/mai/app/MAIAPP0103'
import MAINOT0102 from 'app/pages/mai/not/MAINOT0102'
import _ from 'lodash'
import React from 'react'
import useBasePage from '../hooks/base-page.hook'
import { WtcnsUrlAdr } from '../hooks/util/commonCode.hook'
import Loader from '../layouts/loader/Loader'
import { comUtil } from '../utils'
import { getAppMode, getLocalDateTime, isLocal } from '../utils/comUtil'
import { useProgressDialog } from './CommonUIProvider'

/*======================================================================
 * @ 업무설명 : URL 직접치고 들어오는거 방지, CSRF 토큰 셋팅
 * @ 파 일 명 : src\app\shared\context\VerifyPage.tsx
 * @ 화면 ID :
 * @ 프로그램ID :
 * @ASIS :
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     김상돈           2025.07.29     최초작성
 *======================================================================
 */
export const VerifyPage: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const router = useBasePage()

    const [verifyPage, { isFetching }] = useLazySelectCom0204Query()
    const [fetch0102] = useLazySelectCacheInfoQuery()

    const [verifyPageInfo, setVerifyPageInfo] = React.useState<Com0204CtlrOut>()
    const [tkn, setTkn] = React.useState<string>()
    const [triggerMenuInfo] = useLazySelectMnu0102Query()
    const [menuInfo, setMenuInfo] = React.useState<MnuList[]>()
    const [pathName, setPathName] = React.useState<string>()
    const notRequireMenuList = [
        '/pub',
        '/com/ocr/Quram',
		'/com/ocr/ComtrueStart',
        '/com/ocr/idcard',
        '/com/ocr/kpassport',
        '/com/ocr/passport',
        '/auth',
    ]

    const verifyPageList = [
        '/pub',
        '/com/ocr/Quram',
		'/com/ocr/ComtrueStart',
        '/com/ocr/idcard',
        '/com/ocr/kpassport',
        '/com/ocr/passport',
    ]

    const authPageList = [
        '/auth/error',
        '/auth/500',
        '/auth/404',
        '/auth/fail',
        '/auth/dateConversion',
    ]

    const goPageWhiteList = [
        '/gw', //게이트웨이
        '/mai/app/MAIAPP0101', //메인
        '/mai/app/MAIAPP0102', //지점별메인
        '/prd/man/PRDMAN0101', //상품몰
        '/fns/sbk/FNSSBK0101', //스마트뱅킹 가입및해지
        '/fns/frx/FNSFRX0101', //모두다환전
        '/etc/evt/ETCEVT0101', //이벤트
        '/etc/brc/ETCBRC0101', //지점찾기
        '/csc/man/CSCMAN0101', //고객지원
        '/csc/uif/CSCUIF0101', //서비스소개
        '/csc/uif/CSCUIF0101', //이용안내
        '/etc/not/ETCNOT0201', //공지사항
        '/csc/faq/CSCFAQ0101', //자주묻는 질문
        '/csc/tip/CSCTIP0101', //IBK모바일브랜치활용법
        '/etc/doc/ETCDOC0701', //개인신용정보 마케팅활용 동의
        '/com/ocr/COMOCR0106', //모바일신분증
    ]
        .concat(verifyPageList)
        .concat(authPageList)

    const [showLogin, setShowLogin] = React.useState<boolean>(false)
    const [showNotice, setShowNotice] = React.useState<boolean>(false)
    const [noticeData, setNoticeData] = React.useState<noTiList>()
    const isNotRequireMenuList = notRequireMenuList.some((x) =>
        window.location.pathname.includes(x)
    )
    const requireVerify = !verifyPageList
        .concat(authPageList)
        .some((x) => window.location.pathname.includes(x))

    // const dispatch = useAppDispatch()
    const { hide: hideLoadingDialog } = useProgressDialog()
    React.useEffect(() => {
        ;(async () => {
            //화면 전환 시 물고있던 로딩 강제 해제
            hideLoadingDialog(true)

            // if (
            //     window.sessionStorage.getItem('nob') !== 'true' &&
            //     !authPageList.some((x) => window.location.pathname.includes(x))
            // ) {
            //     window.sessionStorage.setItem('nob', 'true')
            //     dispatch(bankingClear())
            //     dispatch(mobileClear())
            //     dispatch(userClear())
            // }

            comUtil.setUserData('globalLoading', true)
            /**=====================================================================
             * 1. 화면검증 csrf 토큰 획득
             =====================================================================*/
            if (requireVerify) {
                const verifyInfo = await verifyPage()

                if (!isLocal) {
                    if (verifyInfo.isError) {
                        const verifyError = verifyInfo.error
                        if ('data' in verifyError) {
                            if (verifyError.data['msgCd'] === 'E39993') {
                                router.replacePageWithData(
                                    '/auth/dateConversion',
                                    {
                                        msg: verifyError.data['bscMsg'],
                                    }
                                )
                            } else {
                                router.replacePage('/auth/500')
                            }
                        } else {
                            router.replacePage('/auth/500')
                        }
                        return
                    }
                }

                if (verifyInfo.isSuccess) {
                    comUtil.setUserData('tkn', verifyInfo.data.pageAuthKey)
                    setTkn(verifyInfo.data.pageAuthKey)
                }

                setVerifyPageInfo(verifyInfo.data)
            }

            /**=====================================================================
             * TMP 내부오픈 비밀번호페이지
             =====================================================================*/
            let showLogin = false

            if (getAppMode() === 'production' && requireVerify) {
                const result0102 = await fetch0102({
                    dsrnTgtBacd: '110',
                    ccddId: '',
                    cdgpId: 'TMP_PW_CHK',
                })

                if (result0102.isError) {
                    router.replacePage('/auth/500')
                } else {
                    const data = result0102.data
                        .data[0] as unknown as WtcnsUrlAdr

                    if (
                        data.cdAtrbEtc1Con === 'Y' &&
                        window.sessionStorage.getItem('isLogined') !== 'true'
                    ) {
                        setShowLogin(true)
                        showLogin = true
                    } else {
                        setShowLogin(false)
                        showLogin = false
                    }
                }
            }

            if (!showLogin) {
                /**=====================================================================
                 * 2. 공지알림
                 =====================================================================*/
                let showNoticeVari = false
                if (!window.location.pathname.includes('/auth')) {
                    const result0102 = await fetch0102({
                        dsrnTgtBacd: '001',
                        ccddId: '',
                        cdgpId: '',
                    })

                    if (result0102.isError) {
                        router.replacePage('/auth/500')
                    } else {
                        const datas = result0102.data
                            .data as unknown as noTiList[]
                        datas.forEach((data) => {
                            let toDay = getLocalDateTime('YYYYMMDDhhmmss')
                            if (
                                Number(data.expuSttgTs) <= Number(toDay) &&
                                Number(data.expuFnshTs) >= Number(toDay)
                            ) {
                                if (
                                    data.pbntPpupTcd === '3' &&
                                    getAppMode() !== 'local'
                                ) {
                                    setShowNotice(true)
                                    setNoticeData(data)
                                    showNoticeVari = true
                                }
                            }
                        })
                    }
                }
                if (!showNoticeVari) {
                    setShowNotice(false)
                }
                /**=====================================================================
                 * 3. 메뉴조회
                 =====================================================================*/
                let menuDic: MenuDict = {}

                if (!isNotRequireMenuList) {
                    const { data, isError, isSuccess } = await triggerMenuInfo()

                    let errorCase = false

                    if (isSuccess) {
                        if (_.isEmpty(data.data)) {
                            errorCase = true
                        } else {
                            setMenuInfo(data.data)
                            data.data.forEach((rawMenu) => {
                                menuDic[rawMenu.menuId] = rawMenu
                            })
                        }
                    }

                    if (isError) {
                        errorCase = true
                    }

                    if (errorCase) {
                        if (!window.location.pathname.includes('/auth')) {
                            router.replacePage('/auth/500')
                        }
                    }
                }

                /**=====================================================================
                 * 4. location의 state에 goPage가 없는 경우 화이트리스트 아닌경우 오류임
                 *  - 메뉴ID로 들어오는 경우 menuDic에서 실제 경로 확인
                 =====================================================================*/
                if (!isLocal && !_.isEmpty(menuDic)) {
                    const originalPath = window.location.pathname
                    let targetPath = window.location.pathname

                    //메뉴ID인지? /M1234
                    const menuId = originalPath.split('/')[1]
                    if (menuId in menuDic) {
                        targetPath = menuDic[menuId].menuUrlAdr.replace(
                            '.tsx',
                            ''
                        )
                    }

                    //goPage 검증
                    if (
                        targetPath !== '/' &&
                        !goPageWhiteList.some((x) => targetPath.includes(x))
                    ) {
                        if (!window.history.state?.['usr']?.['goPage']) {
                            router.replacePage('/auth/404')
                            return
                        }
                    }
                }
            }

            setPathName(window.location.pathname)
        })()
    }, [window.location.pathname])

    if (showLogin) {
        return <MAIAPP0103 />
    }
    if (showNotice) {
        return <MAINOT0102 notiInfoOb={noticeData} />
    }

    if (pathName === window.location.pathname) {
        if (requireVerify) {
            if (verifyPageInfo && verifyPageInfo?.pageAuthKey === tkn) {
                if (!isNotRequireMenuList) {
                    if (menuInfo) {
                        return <>{children}</>
                    }
                } else {
                    return <>{children}</>
                }
            }
        } else {
            if (!isNotRequireMenuList) {
                if (menuInfo) {
                    return <>{children}</>
                }
            } else {
                return <>{children}</>
            }
        }
    }

    return <Loader />
}
